module.exports = __webpack_public_path__ + "static/media/General.729ce408.png";